'use client';

import { Children, cloneElement } from 'react';

import { useHeader } from '../context/HeaderContextProps';

import type { HeaderContextProps } from '../context/HeaderContextProps';
import type { FC, ReactElement } from 'react';

export interface HeaderConsumerProps {
  children: ReactElement | ReactElement[];
  props?: [keyof HeaderContextProps];
}

// { [Key in keyof TObj]: Key extends TProps ? TObj[Key] : never }
// {[K in keyof TProps]: K extends keyof TObj? TObj[K] : never }
// { [K in keyof TProps]: Pick<TObj, K> }
const pickProps = <TObj, TProps extends Array<keyof TObj>>(
  obj: TObj,
  props: TProps
): { [K in keyof TObj]: K extends keyof TProps ? TObj[K] : never } =>
  props.reduce(
    (acc, key) => ({
      ...acc,
      ...(obj[key] ? { [key]: obj[key] } : {}),
    }),
    {}
  );

export const HeaderConsumer: FC<HeaderConsumerProps> = ({
  children,
  props,
}) => {
  let headerContext = useHeader();

  if (props) {
    headerContext = pickProps( headerContext, props );
  }

  return (
    <>
      {Children.map( children, (child, index) =>
        cloneElement( child, { key: index, ...headerContext } ) )}
    </>
  );
};
